import React from "react";
import { DataTableDataType, FormatterType } from "../../../../types";
import { Icon } from "../../../icon";

const EditTableFormatter = <T extends DataTableDataType>(props: FormatterType<T>) => {
  const { onClick, rowIndex, row } = props;
  return (
    <Icon
      iconName="fa-trash-alt"
      onClick={() => {
        if (!!onClick) {
          onClick(rowIndex!, row);
        }
      }}
    />
  );
};

export default EditTableFormatter;
